import React, { useEffect, useState } from 'react';
import { 
  Box, Typography, IconButton, Paper, Grid, Table, TableBody, 
  TableCell, TableContainer, TableHead, TableRow, Avatar, Stack, Button, Chip 
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GroupsIcon from '@mui/icons-material/Groups';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { commonRunQuery } from "../../util/API/loans";
const ProductManagementDetail = ({ product, onBack }) => {
  const[participatingInvestors, setparticipatingInvestors] = useState([])
  const[totalCommitted, settotalCommitted] = useState(0)
  // Mock data for investors specific to this product
  // const participatingInvestors = [
  //   { id: 1, name: 'John Doe', email: 'john@doe.com', committed: '$50,000', funded: '$40,000', share: '2.5%' },
  //   { id: 3, name: 'Global Capital LP', email: 'ops@globalcap.com', committed: '$2,000,000', funded: '$1,500,000', share: '97.5%' },
  // ];
        useEffect(() => {
        getProductDetails();
      }, [product]);
  const getProductDetails = async () => {
  try {
    const response = await commonRunQuery(362, product.id);
    console.log(JSON.stringify(response));

    const records = response?.data?.body?.record;

    if (records) {
      const recordsArray = Array.isArray(records) ? records : [records];
      const mapped = recordsArray.map((item) => {
        const u = item.u;
        const r = item.record;

        const totalCommitted = Number(r.total_committed);
        const totalCalled    = Number(r.total_called);
        const totalUncalled  = Number(r.total_uncalled);

        // Calculate share % of each investor vs total fund size
        const fundSize = Number(product.totalFundSize) || 1; // avoid divide by zero
        const sharePercent = ((totalCommitted / fundSize) * 100).toFixed(2) + '%';
        
        return {
          id: u.investor_id,
          // name: `${u.firstName} ${u.lastName}`,
          name: `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.otherNames,
          email: '',                    // not in API, leave empty or remove that cell
          committed: `$${totalCommitted.toLocaleString('en-US', { minimumFractionDigits: 2 })}`,
          funded:    `$${totalCalled.toLocaleString('en-US', { minimumFractionDigits: 2 })}`,
          uncalled:  `$${totalUncalled.toLocaleString('en-US', { minimumFractionDigits: 2 })}`,
          tvpi:      Number(r.avg_tvpi).toFixed(2),
          dpi:       Number(r.avg_dpi).toFixed(2),
          rvpi:      '—',               // not in API response
          share:     sharePercent,
          lastSubscription: r.last_subscription_date,
        };
      });

      setparticipatingInvestors(mapped);
      let totalComittedVal = 0;
      records.forEach((item) => {
        totalComittedVal += Number(item.record.total_committed);
      });
      settotalCommitted(
        `$${totalComittedVal.toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
      );
    }
  } catch (error) {
    console.error(error);
  }
};
  return (
    <Box className="dashboard-card" sx={{ p: 1 }}>
      {/* Header */}
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <IconButton onClick={onBack} sx={{ bgcolor: '#f5f5f5', '&:hover': { bgcolor: '#e0e0e0' } }}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h5" fontWeight="bold" color="#002e4c">
            {product.title} 
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Fund Creator: <strong>{product.creator}</strong> | Manage capital calls and participation.
          </Typography>
        </Box>
      </Box>

      {/* Quick Stats Summary */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: '#e3f2fd' }}><TrendingUpIcon color="primary" /></Avatar>
            <Box>
              <Typography variant="caption" color="textSecondary">Total Commitment</Typography>
              <Typography variant="h6" fontWeight="bold">{totalCommitted}</Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: '#f1f8e9' }}><GroupsIcon color="success" /></Avatar>
            <Box>
              <Typography variant="caption" color="textSecondary">Active Investors</Typography>
              <Typography variant="h6" fontWeight="bold">{participatingInvestors.length}</Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Investor Breakdown Table */}
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ mt: 2, mb: 2 }}>
        Investor Participation Breakdown
      </Typography>
      
      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee' }}>
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f9f9f9' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Investor</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Committed</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Called</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Uncalled</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>TVPI</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>DPI</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>RVPI</TableCell>
              {/* <TableCell sx={{ fontWeight: 'bold' }}>% Ownership</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
    {participatingInvestors.length === 0 ? (
  <TableRow>
    <TableCell colSpan={8} align="center" sx={{ py: 4, color: 'text.secondary' }}>
      No records found
    </TableCell>
  </TableRow>
) : participatingInvestors.map((inv) => (
  <TableRow key={inv.id} hover>
    <TableCell>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Avatar sx={{ width: 30, height: 30, fontSize: '0.8rem', bgcolor: '#002e4c' }}>
          {/* {inv.name.charAt(0)} */}
        </Avatar>
        <Box>
          <Typography variant="body2" fontWeight="600">{inv.name}</Typography>
          <Typography variant="caption" color="textSecondary">
            Last invested: {new Date(inv.lastSubscription).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
          </Typography>
        </Box>
      </Stack>
    </TableCell>
    <TableCell>{inv.committed}</TableCell>
    <TableCell>{inv.funded}</TableCell>
    <TableCell>{inv.uncalled}</TableCell>
    <TableCell sx={{ fontWeight: 600, color: '#1a73e8' }}>{inv.tvpi}</TableCell>
    <TableCell>{inv.dpi}</TableCell>
    <TableCell>{inv.rvpi}</TableCell>
    {/* <TableCell>
      <Chip label={inv.share} size="small" variant="outlined" sx={{ fontWeight: 'bold' }} />
    </TableCell> */}
  </TableRow>
))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ProductManagementDetail;